import { render } from "./NewsletterForm.vue?vue&type=template&id=53ca8ef2"
import script from "./NewsletterForm.vue?vue&type=script&lang=js"
export * from "./NewsletterForm.vue?vue&type=script&lang=js"

import "./NewsletterForm.vue?vue&type=style&index=0&id=53ca8ef2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__